<template>
  <div class="app-main-inner" type="primary" style="background-color: #F5F7FA;">
    <div class="app-main-inner-row">
      <div class="triggers">
        <template v-if="!isEdit">
          <el-button type="primary" :disabled="oneOffice.uuid===''" @click="toAddOffice">{{ $t('CargoMsg.Cargo_AddBranch') }}</el-button>
          <el-button type="primary" :disabled="oneOffice.uuid===''||!!treeNode.root" @click="popCopyOffice">{{ $t('CargoMsg.Cargo_CopyBranch') }}</el-button>
          <el-button type="primary" :disabled="oneOffice.uuid===''" @click="toAddDept">{{ $t('CargoMsg.Cargo_AddDept') }}</el-button>
          <el-button type="primary" :disabled="oneOffice.uuid===''" @click="toEditOffice">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button v-if="!(oneOffice.uuid===''||treeNode.hasChild)" type="danger" @click="toDel">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          <el-button type="primary" :disabled="oneOffice.uuid===''" @click="popBankAccount">{{ $t('CargoMsg.Cargo_BankAccount') }}</el-button>
          <el-button type="primary" :disabled="oneOffice.uuid===''" @click="popInvoicingInfo">{{ $t('CargoMsg.Cargo_InvoicingInformation') }}</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="toSaveOffice">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button type="primary" @click="toCancelSaveOffice">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </template>
      </div>
    </div>
    <div class="app-main-inner-row">
      <div class="tabs-container" style="padding: 0;">
        <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
          <!--基本信息-->
          <el-tab-pane :key="1" :label="$t('SeaExport.BasicInfo')" name="basicInfo">
            <div class="app-main-inner-row input-dialog">
              <el-form ref="officeForm" style="width:100%;" label-position="left" label-width="120px">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('SeaExport.GroupCode')">
                      <el-input v-model="oneOffice.code" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_BranchCnName')">
                      <el-input v-model="oneOffice.chineseName" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ChineseAddress')">
                      <el-input v-model="oneOffice.chineseAddress" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_BranchEnName')">
                      <el-input v-model="oneOffice.englishName" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_City')">
                      <el-input v-model="oneOffice.cityName" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_PostalCode')">
                      <el-input v-model="oneOffice.zipCode" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Fax')">
                      <el-input v-model="oneOffice.fax" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                      <el-input v-model="oneOffice.phone" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Email')">
                      <el-input v-model="oneOffice.email" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_LocalCurrency2')">
                      <cargo-advance-select
                        filterable
                        :select-type="selectTypeNames.basic_data_Currency"
                        :default-value="oneOffice.currency"
                        :disabled="!isEdit"
                        :clearable="false"
                        class="input-color"
                        @parentCallBack="p=>{oneOffice.currency=p.value}"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_DefaultAirport')">
                      <cargo-advance-select
                        ref="airportSelect"
                        no="airportSelect"
                        :disabled="!isEdit"
                        :select-type="selectTypeNames.basic_data_Airport"
                        filterable
                        :default-value="oneOffice.airport"
                        tag-name="englishName"
                        style="flex:1"
                        class="input-color"
                        @parentCallBack="p=>{oneOffice.airport=p.value}"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_DefaultHarbor')">
                      <cargo-advance-select
                        ref="seaportSelect"
                        no="seaportSelect"
                        :disabled="!isEdit"
                        :select-type="selectTypeNames.basic_data_Seaport"
                        filterable
                        :default-value="oneOffice.seaport"
                        tag-name="englishName"
                        style="flex:1"
                        class="input-color"
                        @parentCallBack="p=>{oneOffice.seaport=p.value}"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_DefaultTimeZone')">
                      <cargo-advance-select
                        ref="timezoneSelect"
                        no="timezoneSelect"
                        :disabled="!isEdit"
                        :select-type="selectTypeNames.basic_data_Timezone"
                        filterable
                        :default-value="oneOffice.timezone"
                        tag-name="regionCn"
                        style="flex:1"
                        class="input-color"
                        @parentCallBack="p=>{oneOffice.timezone=p.value}"
                      />
                    </el-form-item>
                    <el-form-item :label="`${$t('baseInfo.partner.region')}（${$t('baseInfo.partner.area')}）`" style="margin-right: 0">
                      <cargo-advance-select
                        ref="region"
                        no="region"
                        :disabled="!isEdit"
                        :select-type="selectTypeNames.basic_data_Country"
                        filterable
                        :callback-params="{key:'region'}"
                        callback-method-type="value"
                        :default-value="oneOffice.region"
                        style="width: 160px"
                        @parentCallBack="p=>{oneOffice.region=p.value}"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.StreetNumber')">
                      <el-input v-model="oneOffice.streetNo" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <hr>
                    <span class="title">{{ $t('Partners.oceanBillOfLadingAddress') }}</span>
                    <el-form-item
                      v-for="count in 6"
                      :key="'seaAddressLine'+count"
                    >
                      <el-input
                        :ref="'seaAddressLine'+count"
                        v-model="oneOffice['seaAddressLine'+count]"
                        :no="'seaAddressLine'+count"
                        :filter-chars="false"
                        :disabled="!isEdit"
                        style="flex:1"
                        @dblclick.native="showBlAddressDialog"
                        @change="()=>wrapAddr(oneOffice,'seaAddressLine'+count,count+1 > 6 ? null :'seaAddressLine'+(count+1),maxChars)"
                      />
                    </el-form-item>
                    <hr>
                    <span class="title">{{ $t('Partners.airBillOfLadingAddress') }}</span>
                    <el-form-item
                      v-for="count in 6"
                      :key="'airAddressLine'+count"
                    >
                      <el-input
                        :ref="'airAddressLine'+count"
                        v-model="oneOffice['airAddressLine'+count]"
                        :no="'airAddressLine'+count"
                        :filter-chars="false"
                        :disabled="!isEdit"
                        style="flex:1"
                        @dblclick.native="showAirAddressDialog"
                        @change="()=>wrapAddr(oneOffice,'airAddressLine'+count,count+1 > 6 ? null :'airAddressLine'+(count+1),maxChars)"
                      />
                    </el-form-item>
                    <hr>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('CargoMsg.Cargo_RMBAccount')">
                      <el-input v-model="oneOffice.rmbAccount" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_USDAccount')">
                      <el-input v-model="oneOffice.usdAccount" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ReceiveRMBAccount')">
                      <el-input v-model="oneOffice.receiveRmbAccount" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ReceiveUSDAccount')">
                      <el-input v-model="oneOffice.receiveUsdAccount" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_MultiHeaderBankMode')">
                      <el-checkbox v-model="oneOffice.multiTitleBankMode" :disabled="!isEdit">{{ $t('CargoMsg.Cargo_Enable') }}</el-checkbox>
                      <el-tooltip :content="$t('CargoMsg.Cargo_ConfirmBeforeEnable')" placement="right">
                        <svg-icon icon-class="question" style="margin-left: 10px;" />
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_OverseasBillingAddress')">
                      <el-input v-model="oneOffice.overseaAddress" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_DomesticBillingAddress')">
                      <el-input v-model="oneOffice.localAddress" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_OverseasEDICode')">
                      <el-input v-model="oneOffice.ediCode" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ValueAddedTaxRate')">
                      <el-input-number v-model="oneOffice.taxRate" :disabled="!isEdit" :step="0.1" :precision="3" controls-position="right" :min="0" :max="100" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoicingTaxRate')">
                      <el-input-number v-model="oneOffice.invoiceTaxRate" :disabled="!isEdit" :step="0.1" :precision="3" controls-position="right" :min="0" :max="100" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_SettleEmail')">
                      <el-input v-model="oneOffice.clearEmail" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_TaxationSystemAPIAddress')">
                      <el-input v-model="oneOffice.sajtInvoiceService" type="textarea" rows="3" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_TaxControlMachineNo')">
                      <div style="display: flex">
                        <div style="width: 79%">
                          <el-input v-model="clientNos" :disabled="true" class="input-color" />
                        </div>
                        <div style="width: 20%;padding-left: 2%;">
                          <el-button type="primary" :disabled="!oneOffice.uuid" @click="editClientNoHandler">...</el-button>
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoiceHeader')">
                      <el-input v-model="oneOffice.invoiceTitle" :disabled="true" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('Partners.invoiceAddress')">
                      <el-input v-model="oneOffice.invoiceAddress" :disabled="true" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_DepositBankAndAccountNo')">
                      <cargo-rich-textarea ref="depositBankAccount" v-model="oneOffice.depositBankAccount" :disabled="true" :text-chars="0" :warning-count="-1" style="min-height: unset;" />
                    </el-form-item>
                    <el-form-item :label="$t('Partners.registrationNumber')">
                      <el-input v-model="oneOffice.taxAccount" :disabled="true" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('SystemMaintenance.WhtTax')">
                      <el-checkbox v-model="oneOffice.whtTaxMode" :disabled="!isEdit">{{ $t('CargoMsg.Cargo_Enable') }}</el-checkbox>
                      <el-tooltip :content="$t('SystemMaintenance.WhtTaxTip')" placement="right">
                        <svg-icon icon-class="question" style="margin-left: 10px;" />
                      </el-tooltip>
                    </el-form-item>
                    <hr>
                    <el-form-item :label="$t('CargoMsg.Cargo_ElectronicInvoicePlatformCode')">
                      <el-input v-model="oneOffice.userNameEi" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ElectronicInvoice')">
                      <el-input v-model="oneOffice.passWordEi" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ElectronicInvoiceTaxpayer')">
                      <el-input v-model="oneOffice.taxPayerIdEi" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ElectronicInvoiceAuthCode')">
                      <el-input v-model="oneOffice.authorizationCodeEi" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ElectronicInvoiceRequestAddress')">
                      <el-input v-model="oneOffice.invoiceServiceEi" type="textarea" rows="3" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoiceCancellationRequestAddress')">
                      <el-input v-model="oneOffice.invoiceInvalidEi" type="textarea" rows="3" :disabled="!isEdit" class="input-color" />
                    </el-form-item>
                    <el-form-item v-if="isNewDelegation" :label="$t('CargoMsg.Cargo_AssociatePartners')">
                      <cargo-advance-select
                        :disabled="!isEdit"
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{active:true}"
                        tag-name="chineseName"
                        tag-value="uuid"
                        style="width:100%;"
                        filterable
                        class="input-color"
                        :default-value="oneOffice.companyUuid"
                        placeholder=" "
                        @parentCallBack="p=>{companyUuidChangeHandler(p)}"
                      />
                    </el-form-item>
                    <el-form-item label="NVOCC SCAC">
                      <el-input
                        v-model="oneOffice.nvoccScac"
                        type="textarea"
                        :rows="3"
                        :disabled="!isEdit"
                        class="input-color"
                        @dblclick.native="showAdvanceTextDialog('NVOCC SCAC',oneOffice.nvoccScac,val=>{oneOffice.nvoccScac=val})"
                      />
                    </el-form-item>
                    <hr>
                    <el-form-item :label="$t('SystemMaintenance.NotEntityCompany')">
                      <el-checkbox v-model="oneOffice.notEntityCompany" :disabled="!isEdit">{{ $t('SystemMaintenance.Marked') }}</el-checkbox>
                      <el-tooltip :content="$t('SystemMaintenance.NotEntityCompanyTip')" placement="right">
                        <svg-icon icon-class="question" style="margin-left: 10px;" />
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <div class="app-main-inner-row" style="margin-top: -10px">
                      <cargo-ag-grid
                        :show-side-bar="false"
                        :grid-options="imageGrid.gridOptions"
                        :column-defs="imageGridColumnDef"
                        :row-data="imageGrid.rowData"
                        style="width:100%;height:630px;"
                      />
                    </div>
                    <div class="app-main-inner-row row-grid-dialog">
                      <div class="triggers" style="display: flex">
                        <div style="padding-right: 5px">
                          <el-upload
                            action=""
                            accept="image/png, image/jpeg"
                            :show-file-list="false"
                            :on-change="toChooseImage"
                            :file-list="[]"
                            :limit="1"
                            :on-exceed="toChooseImage"
                            :auto-upload="false"
                          >
                            <el-button slot="trigger" size="mini" :disabled="!isEdit" type="primary">{{ $t('Partners.SelectFile') }}</el-button>
                          </el-upload>
                        </div>
                        <div>
                          <el-button size="mini" :disabled="!isEdit" type="primary" @click="commitImage">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
                          <el-button size="mini" :disabled="!isEdit || !imageGrid.selectedData" type="danger" @click="toBatchDelImage">{{ $t('Partners.DeleteFile') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <!--开票配置-->
          <el-tab-pane v-if="$store.getters.isPlatform" :key="2" :label="$t('CargoMsg.InvoiceConfig')" name="invoiceConfig">

            <div>
              <el-form style="width:100%;" label-position="right" label-width="120px">
                <el-form-item :label="' '">
                  <el-radio-group v-model="oneOffice.titleMode" no="titleMode" :disabled="!isEdit" style="width:300px; display: flex">
                    <el-radio no="SingleTitleMode" :label="0" style="margin-right:10px">{{ $t('CargoMsg.Cargo_SingleTitleMode') }} </el-radio>
                    <el-radio no="MultipleTitleMode" :label="1">{{ $t('CargoMsg.Cargo_MultipleTitleMode') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>

            <div v-show="oneOffice.titleMode">
              <office-invoice-config ref="officeInvoiceConfig" :office-id="oneOffice.officeId" :is-edit="isEdit" />
            </div>
            <div v-show="!oneOffice.titleMode" class="app-main-inner-row input-dialog">
              <el-form style="width:100%;" label-position="right" label-width="120px">
                <el-row :gutter="10">
                  <el-form-item :label="$t('CargoMsg.InvoiceChannel')" required>
                    <el-select v-model="oneOffice.invoiceChannel" no="invoiceChannel" :disabled="!isEdit" style="width:300px;" @change="invoiceChannelChange">
                      <el-option
                        v-for="item in SystemConstants.INVOICE_CHANNEL_STATUS"
                        :key="item.code"
                        :label="item.chineseName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                  <!--诺诺网全电发票:NUONUO-->
                  <div v-if="isNuoNuo">
                    <el-form-item :label="'APPkey'" required>
                      <el-input v-model="oneOffice.appKey" no="appKey" :disabled="!isEdit" class="input-color" style="width:300px;" />
                    </el-form-item>
                    <el-form-item :label="'APPSecret'" required>
                      <el-input v-model="oneOffice.appSecret" no="appSecret" :disabled="!isEdit" style="width:300px;" />
                    </el-form-item>
                    <el-form-item :label="'Token'" required>
                      <el-input v-model="oneOffice.token" no="token" :disabled="!isEdit" style="width:300px;" />
                    </el-form-item>
                  </div>
                  <!--百旺金穗云:BWJSY-->
                  <div v-if="isBwjsy">
                    <el-form-item :label="'APPId'" required>
                      <el-input v-model="oneOffice.appKey" no="APPId" :disabled="!isEdit" class="input-color" style="width:300px;" />
                    </el-form-item>
                    <el-form-item :label="'APPSecret'" required>
                      <el-input v-model="oneOffice.appSecret" no="appSecret" :disabled="!isEdit" style="width:300px;" />
                    </el-form-item>
                  </div>
                  <div v-if="isNuoNuo || isBwjsy">
                    <el-form-item :label="$t('CargoMsg.Invoicer')" required>
                      <cargo-ag-grid
                        :show-side-bar="false"
                        :grid-options="invoiceGrid.gridOptions"
                        :column-defs="invoiceGridColumnDefs"
                        :row-data="finalInvoiceRowData"
                        :style="(isBwjsy ? 'width:670px;' : 'width:500px;')+'height:200px;'"
                        @gridReady="params=>this.invoiceGrid.gridApi=params.api"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.InvoicerConfig')" required>
                      <el-radio-group v-model="oneOffice.invoicerConfig" no="invoicerConfig" :disabled="!isEdit" style="width:300px;">
                        <el-radio no="OnlyInvoicer" :label="0" style="margin-right:10px">{{ $t('CargoMsg.OnlyInvoicer') }}</el-radio>
                        <el-radio no="AllInvoicer" :label="1">{{ $t('CargoMsg.AllInvoicer') }}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-row>

                <!--自定义配置字段-->
                <el-row :gutter="10">
                  <el-form-item :label="$t('CargoMsg.Cargo_CustomFields') + '1'">
                    <el-input v-model="oneOffice.customField1" no="customField1" :disabled="!isEdit" style="width:300px;" />
                    <el-tooltip v-if="isNuoNuo" :content="$t('CargoMsg.Cargo_NuoNuoTipOne')" placement="right-end" style="padding-left: 7px;">
                      <i class="el-icon-warning" style="cursor: pointer;color: orange;" />
                    </el-tooltip>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_CustomFields') + '2'">
                    <el-input v-model="oneOffice.customField2" no="customField2" :disabled="!isEdit" style="width:300px;" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_CustomFields') + '3'">
                    <el-input v-model="oneOffice.customField3" no="customField3" :disabled="!isEdit" style="width:300px;" />
                  </el-form-item>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <!--进项税配置-->
          <el-tab-pane v-if="$store.getters.isPlatform" :key="5" :label="$t('CargoMsg.Cargo_TaxInputConfig')" name="inputTaxConfig">
            <office-input-tax-config ref="officeInputTaxConfig" :office-id="oneOffice.officeId" :is-edit="isEdit" />
          </el-tab-pane>
          <!--反恐舱单配置-->
          <el-tab-pane :key="3" :label="$t('SeaExport.CounterTerrorismManifestConfiguration')" name="manifestConfig">
            <div class="app-main-inner-row input-dialog" style="height: 735px">
              <el-form style="width:100%;" label-position="right" label-width="120px">
                <el-row :gutter="10">
                  <el-form-item :label="$t('CargoMsg.Cargo_EFreighAMSAccount')">
                    <el-input
                      v-model="oneOffice.efreighAms"
                      type="textarea"
                      :rows="1"
                      :disabled="!isEdit"
                      class="input-color"
                      @dblclick.native="showAdvanceTextDialog($t('CargoMsg.Cargo_EFreighAMSAccount'),oneOffice.efreighAms,val=>{oneOffice.efreighAms=val})"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_EFreighACIAccount')">
                    <el-input
                      v-model="oneOffice.efreighAci"
                      type="textarea"
                      :rows="1"
                      :disabled="!isEdit"
                      class="input-color"
                      @dblclick.native="showAdvanceTextDialog($t('CargoMsg.Cargo_EFreighACIAccount'),oneOffice.efreighAci,val=>{oneOffice.efreighAci=val})"
                    />
                  </el-form-item>
                  <el-form-item label="E-Freight Company Code" title="E-Freight Company Code">
                    <el-input
                      v-model="oneOffice.efreighCompanyCode"
                      type="textarea"
                      :rows="3"
                      :disabled="!isEdit"
                      class="input-color"
                      @dblclick.native="showAdvanceTextDialog('E-Freight Company Code',oneOffice.efreighCompanyCode,val=>{oneOffice.efreighCompanyCode=val})"
                    />
                  </el-form-item>

                  <el-form-item :label="$t('SeaExport.AfrAccount')">
                    <el-input
                      v-model="oneOffice.jsAfrAccount"
                      :rows="1"
                      :disabled="!isEdit"
                      class="input-color"
                      @dblclick.native="showAdvanceTextDialog($t('SeaExport.AfrAccount'),oneOffice.jsAfrAccount,val=>{oneOffice.efreighCompanyCode=val})"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.AfrPassword')">
                    <el-input
                      v-model="oneOffice.jsAfrPassword"
                      :rows="1"
                      :disabled="!isEdit"
                      class="input-color"
                      @dblclick.native="showAdvanceTextDialog($t('SeaExport.AfrPassword'),oneOffice.jsAfrPassword,val=>{oneOffice.efreighCompanyCode=val})"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.DeclarantEORI')">

                    <div style="display: flex">
                      <div v-if="oneOffice.officeEoriList && oneOffice.officeEoriList.length && oneOffice.officeEoriList.filter(item => item.action !== 'delete').length" class="eori-list">
                        <div v-for="item in oneOffice.officeEoriList" :key="item.uuid || item.newUuid">
                          <div v-if="item.action !== 'delete'" class="eori-item" style="display: flex; align-items: center;">
                            <span style="width: 205px; ">{{ item.eori }}</span>
                            <img v-show="isEdit" src="@/assets/icons/eori-edit.png" alt="" style="margin-left: 5px; cursor: pointer;" @click="eoriEditHandler(item)">
                            <img v-show="isEdit" src="@/assets/icons/eori-delete.png" alt="" style="margin-left: 5px; cursor: pointer;" @click="eoriDeleteHandler(item)">
                            <img v-show="isEdit && canAddEori" src="@/assets/icons/eori-add.png" alt="" style="margin-left: 5px; cursor: pointer;" @click="eoriAddHandler">
                          </div>
                        </div>
                      </div>
                      <div v-else style="display: flex; align-items: center;">
                        <el-input
                          :disabled="true"
                          :title="$t('SeaExport.DeclarantEORI')"
                          no="86"
                        />
                        <img v-show="isEdit" src="@/assets/icons/eori-add.png" alt="" style="margin-left: 5px; cursor: pointer;" @click="eoriAddHandler">
                      </div>
                    </div>
                  </el-form-item>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <!--企微账号托管-->
          <el-tab-pane :key="4" :label="$t('CargoMsg.Cargo_TabEnterpriseWechat')" name="enterpriseWechat">
            <tab-enterprise-wechat :office="oneOffice" :active-tab-name="activeTabName" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="copyOfficeDialog.isShow" :title="$t('CargoMsg.Cargo_CopyBranch')" width="300px;" @close="copyOfficeDialog.isShow=false">
      <div>
        <div>{{ $t('CargoMsg.Cargo_NewBranchInformation') }}</div>
        <el-form :inline="false" label-width="150px" label-position="left">
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('SeaExport.CompanyCode')">
              <el-input v-model="copyOfficeDialog.code" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BranchCnName')">
              <el-input v-model="copyOfficeDialog.chineseName" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BranchEnName')">
              <el-input v-model="copyOfficeDialog.englishName" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_LocalCurrency2')">
              <el-input v-model="copyOfficeDialog.currency" />
            </el-form-item>
          </div>
        </el-form>
        <div style="color:red">{{ $t('SystemMaintenance.NoteCopyFollowingInformation', [oneOffice.chineseName]) }}</div>
        <div style="color:red">{{ $t('SystemMaintenance.N1DepartmentsAndPositionBranch') }}</div>
        <div style="color:red">{{ $t('SystemMaintenance.N2ParameterConfiguration') }}</div>
        <div style="color:red">{{ $t('SystemMaintenance.N3OrderNumberConfiguration') }}</div>
      </div>
      <div slot="footer">
        <el-button size="mini" type="primary" @click="toSubmitCopyOffice">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button size="mini" type="primary" @click="toCancelCopyOffice">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-el-drag-dialog
      custom-class=""
      :close-on-click-modal="false"
      :visible.sync="eoriInfoDialog.visible"
      :title="$t('CargoMsg.Cargo_EORIDetail')"
      class="eori-dialog"
    >
      <el-form :disabled="!isEdit" label-width="110px" label-position="left" style="font-size:14px;margin-left:12px;margin-right: 16px">
        <el-form-item :title="$t('SeaExport.CompanyTitle')">
          <span slot="label" style="color: #1f75d5 !important;">{{ $t('SeaExport.CompanyTitle') }}</span>
          <el-input v-model="eoriInfo.name" no="eoriInfoName" />
        </el-form-item>
        <el-form-item :title="$t('SeaExport.Addr') + '1'">
          <span slot="label" style="color: #1f75d5 !important;">{{ $t('SeaExport.Addr') + '1' }}</span>
          <el-input v-model="eoriInfo.address1" no="eoriInfoAddress2" />
        </el-form-item>
        <el-form-item :title="$t('SeaExport.Addr') + '2'">
          <span slot="label">{{ $t('SeaExport.Addr') + '2' }}</span>
          <el-input v-model="eoriInfo.address2" no="eoriInfoAddress2" />
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: #1f75d5 !important;" :title="$t('SeaExport.HouseNumber')">{{ $t('SeaExport.HouseNumber') }}</span>
          <div style="display: flex; justify-content: space-between;">
            <div style="display: flex; align-items: center; width: 35%;">
              <el-input v-model="eoriInfo.streetNo" :disabled="eoriInfo.noHouseNumberFlag" no="eoriInfoStreetNo" />
              <el-checkbox v-model="eoriInfo.noHouseNumberFlag" style="margin-left: 25px" @change="changeNoHouseNumberFlag">{{ $t('SeaExport.NoHouseNumber') }}</el-checkbox>
            </div>
            <div style="display: flex; align-items: center; width: 50%;">
              <span class="center-label" :title="$t('SeaExport.ZIP')">{{ $t('SeaExport.ZIP') }}</span>
              <el-input v-model="eoriInfo.postalcode" no="eoriInfoPostalcode" />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label" :title="$t('SeaExport.City')">{{ $t('SeaExport.City') }}</span>
          <div style="display: flex; justify-content: space-between;">
            <div style="display: flex; align-items: center; width: 35%;">
              <el-input v-model="eoriInfo.city" no="eoriInfoCity" />
            </div>
            <div style="display: flex; align-items: center; width: 50%;">
              <span class="center-label" :title="$t('SeaExport.Country')">{{ $t('SeaExport.Country') }}</span>
              <cargo-advance-select
                no="sellerCountry"
                :select-type="selectTypeNames.basic_data_Country"
                :cache="false"
                filterable
                :default-value="eoriInfo.country"
                :filter-tag-names="['code','chineseName','name']"
                tag-name="code"
                tag-value="code"
                :show-custom-label-in-option="true"
                :custom-label="(item) => this.isZh ? `${item.code} | ${item.chineseName} | ${item.name}` : `${item.code} | ${item.name}`"
                placeholder=" "
                @parentCallBack="p=>{eoriInfo.country = p.value}"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label" :title="$t('SeaExport.Tel')">{{ $t('SeaExport.Tel') }}</span>
          <div style="display: flex; justify-content: space-between;">
            <div style="display: flex; align-items: center; width: 35%;">
              <el-input v-model="eoriInfo.tel" no="eoriInfoTel" />
            </div>
            <div style="display: flex; align-items: center; width: 50%;">
              <span class="center-label" :title="$t('SeaExport.Email2')">{{ $t('SeaExport.Email2') }}</span>
              <el-input v-model="eoriInfo.email" no="eoriInfoEmail" />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label" title="EORI" style="color: #1f75d5 !important;">{{ 'EORI' }}</span>
          <el-input v-model="eoriInfo.eori" no="eoriInfoEori" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" type="primary" @click="eoriInfoDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button v-show="isEdit" size="mini" type="primary" @click="saveEoriInfo">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      </div>
    </el-dialog>

    <bank-account-title-window
      v-if="bankAccountDialog.visible"
      :visible.sync="bankAccountDialog.visible"
      :tree-node="treeNode"
      :one-office="oneOffice"
      @cancelHandler="cancelHandler"
    />

    <client-no-window
      v-if="editClientNo.visible"
      :visible.sync="editClientNo.visible"
      :row-data="editClientNo.rowData"
      :dept-list="editClientNo.deptList"
      :one-office="oneOffice"
      @cancelHandler="cancelHandler"
      @updateClientNos="updateClientNos"
    />
    <!-- 开票信息弹窗 -->
    <invoicing-info-dialog
      v-if="invoicingInfoDialog.visible"
      :visible.sync="invoicingInfoDialog.visible"
      :office="invoicingInfoDialog.office"
      :tax-control-panels="invoicingInfoDialog.taxControlPanels"
      @officeChange="onOfficeChange"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" :disabled="!isEdit" type="textarea" rows="10" />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOfficeByUuid,
  delOfficeByUuid,
  saveOffice,
  copyOffice,
  loadTaxControlPanelFunc, queryTaxPanelNoStr
} from '@/api/office'
import { saveImage, batchDelImage, querySystemImageFunc } from '@/api/image'

import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import BankAccountTitleWindow from '@/views/cargo/v0/SystemMaintenance/components/role/bankAccountTitleWindow'
import invoicingInfoDialog from '@/views/cargo/v0/SystemMaintenance/components/role/invoicingInfoDialog'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { cache } from '@/utils/cacheManager'
import ClientNoWindow from '@/views/cargo/v0/SystemMaintenance/components/role/clientNoWindow'
import { cacheKeys, getSpecificBasicData, syncSpecificBasicData, updateBasicDataForSingle } from '@/utils/basicDataCache'
import { getUserInfo } from '@/utils/auth'
import { getUserOfficeList } from '@/api/user'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { updateLinkedBranchIdByOffice } from '@/api/company'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { DocumentManage, stringToBool } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import SoNoInput from '@/components/Cargo/Job/soNoInput'
import UIDUtil from '@/utils/uidUtil'
import TabEnterpriseWechat from '@/views/cargo/v0/SystemMaintenance/components/role/tabEnterpriseWechat'
import officeInvoiceConfig from '@/views/cargo/v0/SystemMaintenance/components/role/officeInvoiceConfig'
import officeInputTaxConfig from '@/views/cargo/v0/SystemMaintenance/components/role/officeInputTaxConfig'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'OfficeTab',
  components: {
    officeInputTaxConfig,
    ClientNoWindow,
    BankAccountTitleWindow,
    invoicingInfoDialog,
    cargoAdvanceSelect,
    cargoRichTextarea,
    cargoCompanySelect,
    SoNoInput,
    TabEnterpriseWechat,
    officeInvoiceConfig
  },
  filters: {
    base64Src: function(value) {
      if (!value) {
        return value
      }
      // todo 格式可能也需要做处理
      if (value && value.indexOf('data:image') === 0) {
        // todo
      } else {
        value = 'data:image/png;base64,' + value
      }
      return value
    }
  },
  props: {
    imageTypeList: { type: Array, required: false, default: null },
    deptList: { type: Array, required: false, default: null },
    treeNode: {
      type: Object,
      required: true
    },
    officeCount: { type: Number, default: 0 }
  },
  data() {
    return {
      activeTabName: 'basicInfo',
      loading: false,
      isEdit: false,
      selectTypeNames: TYPE_NAMES,
      SystemConstants,
      imageGrid: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressRowClickSelection: true,
          onRowClicked: this.onRowClick,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        selectedData: null,
        gridParams: {},
        gridApi: {},
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
        rowData: []
      },
      haveCompanyUuidChange: false,
      imageDialog: {
        currentFile: { name: '', size: '', type: '' },
        isShow: false,
        isShowFormDialog: false,
        isEditForm: false,
        chooseImageType: '', // 需要和currentFile.type 对比
        oneImage: {},
        initOneImage: {
          acrossTenant: false,
          clientRefCode: '',
          createdBy: 0,
          dateCreated: '',
          dateModified: '',
          dirty: false,
          extendedData: '',
          height: 0,
          imageFile: '',
          imageType: '',
          modifiedBy: 0,
          name: '',
          officeId: 0,
          tenantId: 0,
          uuid: '',
          version: 1,
          width: 0
        }
      },
      bankAccountDialog: {
        visible: false
      },
      invoicingInfoDialog: {
        visible: false,
        office: {},
        taxControlPanels: []
      },
      // currentEditState: '', // 当前操作状态，编辑本身-editSelf,添加分公司-addSub，复制公司-copy
      copyOfficeDialog: {
        isShow: false,
        code: '',
        uuid: '',
        chineseName: '',
        englishName: '',
        currency: ''
      },
      oneOffice: {},
      initOneOffice: {
        acrossTenant: false,
        agreeTenantBooking: false,
        airAddressLine1: '',
        airAddressLine2: '',
        airAddressLine3: '',
        airAddressLine4: '',
        airAddressLine5: '',
        airAddressLine6: '',
        airport: '',
        authorizationCodeEi: '',
        chineseAddress: '',
        chineseName: '',
        cityName: '',
        clearEmail: '',
        clientRefCode: '',
        streetNo: '',
        code: '',
        companyUuid: '',
        createdBy: 0,
        currency: '',
        dateCreated: '',
        dateModified: '',
        dirty: false,
        ediCode: '',
        email: '',
        englishName: '',
        extendedData: '',
        fax: '',
        invoiceAddress: '',
        invoiceServiceEi: '',
        invoiceInvalidEi: '',
        efreighAci: '',
        efreighAms: '',
        efreighCompanyCode: '',
        invoiceTaxRate: 0,
        invoiceTitle: '',
        localAddress: '',
        modifiedBy: 0,
        officeId: -1,
        overseaAddress: '',
        parentBranchUuid: '',
        passWordEi: '',
        phone: '',
        rmbAccount: '',
        sajtInvoiceService: '',
        seaAddressLine1: '',
        seaAddressLine2: '',
        seaAddressLine3: '',
        seaAddressLine4: '',
        seaAddressLine5: '',
        seaAddressLine6: '',
        seaport: '',
        taxAccount: '',
        taxPayerIdEi: '',
        taxRate: 0,
        tenantId: 0,
        usdAccount: '',
        userNameEi: '',
        uuid: '',
        version: 0,
        zipCode: '',
        timezone: '',
        whtTaxMode: false,
        multiTitleBankMode: false,
        titleMode: '',
        invoiceChannel: 0,
        appKey: '',
        appSecret: '',
        token: '',
        invoicerConfig: 0,
        invoiceConfigs: [],
        region: '',
        notEntityCompany: false,
        officeEoriList: [],
        officeInvoiceTitles: []
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0, autoUppercase: false, autoHalfWord: false
        }
      },
      editClientNo: {
        rowData: [],
        deptList: [],
        visible: false
      },
      isNewDelegation: 0,
      clientNos: '',
      maxChars: 255,
      documentManage: new DocumentManage(),
      invoiceGrid: { // 开票员列表
        gridOptions: {
          singleClickEdit: true,
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        gridParams: {},
        gridApi: {},
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
        rowData: []
      },
      parentCompanyArray: [],
      eoriInfoDialog: {
        visible: false,
        action: ''
      },
      eoriInfo: {
        uuid: '',
        name: '',
        address1: '',
        address2: '',
        streetNo: '',
        postalcode: '',
        tel: '',
        city: '',
        country: '',
        email: '',
        eori: '',
        dateCreated: null,
        action: '',
        noHouseNumberFlag: false
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    url() {
      return URL
    },
    editCheck() {
      return this.isEdit
    },
    imageGridColumnDef() {
      return this.getImageGridColumnDef()
    },
    readonly() {
      return !this.isEdit
    },
    finalInvoiceRowData() {
      return this.invoiceGrid.rowData ? this.invoiceGrid.rowData.filter(p => !p.deleted) : []
    },
    isNuoNuo() { // 诺诺全电
      return this.oneOffice.invoiceChannel === 1
    },
    isBwjsy() { // 百旺金穗云
      return this.oneOffice.invoiceChannel === 2
    },
    nuoNuoColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25, suppressMenu: true,
          sortable: false
        }, {
          headerName: this.$t('CargoMsg.Invoicer'), field: 'invoicer', colId: 'invoicer', width: 180,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_User,
              tagName: 'chineseName',
              callbackParams: { key: 'userId' },
              callbackMethodType: 'value',
              filterable: true,
              clearable: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DefaultInvoiceIssuer'), field: 'defaultInvoiceIssuer', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return stringToBool(params.value) ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('CargoMsg.ExtensionNumber'), field: 'extensionNumber', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 120,
          cellStyle: { textAlign: 'center' },
          cellRenderer: params => {
            const invoicerAdd = this.documentManage.getPath('invoicerAdd')
            const invoicerDel = this.documentManage.getPath('invoicerDel')
            return `<div>
                        <a onclick="${invoicerAdd}()" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${invoicerDel}('${params.data.uuid}', ${params.data.serialNumber})" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          }
        }
      ]
    },
    bwjsyColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25, suppressMenu: true,
          sortable: false
        }, {
          headerName: this.$t('CargoMsg.Invoicer'), field: 'invoicer', colId: 'invoicer', width: 180,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_User,
              tagName: 'chineseName',
              callbackParams: { key: 'userId' },
              callbackMethodType: 'value',
              filterable: true,
              clearable: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DefaultInvoiceIssuer'), field: 'defaultInvoiceIssuer', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return stringToBool(params.value) ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('CargoMsg.FEI_Kpzddm'), field: 'terminalCode', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('CargoMsg.FEI_Yhdm'), field: 'userCode', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 120,
          cellStyle: { textAlign: 'center' },
          cellRenderer: params => {
            const invoicerAdd = this.documentManage.getPath('invoicerAdd')
            const invoicerDel = this.documentManage.getPath('invoicerDel')
            return `<div>
                        <a onclick="${invoicerAdd}()" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${invoicerDel}('${params.data.uuid}', ${params.data.serialNumber})" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          }
        }
      ]
    },
    invoiceGridColumnDefs() {
      return this.isNuoNuo ? this.nuoNuoColumnDefs : this.bwjsyColumnDefs
    },
    canAddEori() {
      // 获取未删除的 EORI 数量
      const activeEoriCount = this.oneOffice.officeEoriList?.filter(item => item.action !== 'delete').length || 0
      return activeEoriCount < 99
    }
  },
  watch: {
    treeNode() {
      this.initData()
    },
    'eoriInfoDialog.visible': {
      handler(newVal, oldVal) {
        if (!newVal) {
          // 重置 this.eoriInfo
          this.eoriInfo = {
            uuid: '',
            name: '',
            address1: '',
            address2: '',
            streetNo: '',
            postalcode: '',
            tel: '',
            email: '',
            city: '',
            country: '',
            eori: '',
            dateCreated: null,
            action: ''
          }
        }
      }
    },
    // 监听 eoriInfo 对象的相关属性
    'eoriInfo.name': {
      handler(val) {
        if (!val) return
        const filtered = val.replace(/[^a-zA-Z0-9\-/,: "'+_]/g, '').slice(0, 70)
        if (filtered !== val) {
          this.eoriInfo.name = filtered
        }
      }
    },
    'eoriInfo.address1': {
      handler(val) {
        if (!val) return
        const filtered = val.replace(/[^a-zA-Z0-9\-/,: "'+_]/g, '').slice(0, 70)
        if (filtered !== val) {
          this.eoriInfo.address1 = filtered
        }
      }
    },
    'eoriInfo.address2': {
      handler(val) {
        if (!val) return
        const filtered = val.replace(/[^a-zA-Z0-9\-/,: "'+_]/g, '').slice(0, 70)
        if (filtered !== val) {
          this.eoriInfo.address2 = filtered
        }
      }
    },
    'eoriInfo.streetNo': {
      handler(val) {
        if (!val) return
        const filtered = val.toUpperCase().replace(/[^A-Z0-9 /-]/g, '').slice(0, 10)
        if (filtered !== val) {
          this.eoriInfo.streetNo = filtered
        }
      }
    },
    'eoriInfo.postalcode': {
      handler(val) {
        if (!val) return
        const filtered = val.toUpperCase().replace(/[^A-Z0-9 /-]/g, '').slice(0, 10)
        if (filtered !== val) {
          this.eoriInfo.postalcode = filtered
        }
      }
    },
    'eoriInfo.city': {
      handler(val) {
        if (!val) return
        const filtered = val.toUpperCase().replace(/[^A-Z0-9 /-]/g, '').slice(0, 35)
        if (filtered !== val) {
          this.eoriInfo.city = filtered
        }
      }
    },
    'eoriInfo.tel': {
      handler(val) {
        if (!val) return
        const filtered = val.replace(/[^+\d \-]/g, '')
        if (filtered !== val) {
          this.eoriInfo.tel = filtered
        }
      }
    },
    'eoriInfo.email': {
      handler(val) {
        if (!val) return
        const filtered = val.replace(/[^a-zA-Z0-9+@ \-_.]/g, '')
        if (filtered !== val) {
          this.eoriInfo.email = filtered
        }
      }
    },
    'eoriInfo.eori': {
      handler(val) {
        if (!val) return
        const filtered = val.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 17)
        if (filtered !== val) {
          this.eoriInfo.eori = filtered
        }
      }
    }
  },
  beforeMount() {
    this.oneOffice = { ...this.initOneOffice }
    const context = this
    this.documentManage.set('invoicerAdd', function() {
      context.invoicerAdd()
    })
    this.documentManage.set('invoicerDel', function(uuid, value) {
      context.invoicerDel(uuid, value)
    })
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.editHandler(false)
      this.fetchOffice()
      this.fetchOfficeImage()
    },
    getImageGridColumnDef() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_Name'), colId: 'name', field: 'name',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Type'), colId: 'imageTypeUuid', field: 'imageTypeUuid', width: 180,
          valueFormatter: (params) => {
            if (this.imageTypeList) {
              const imageType = this.imageTypeList.find(item => item.uuid === params.data.imageTypeUuid)
              if (imageType) {
                return imageType.name
              }
            }
            return ''
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.imageTypeList],
              clearable: false,
              tagValue: 'uuid',
              tagName: 'name',
              filterable: true
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Preview'),
          field: 'imageFile',
          width: 150,
          height: 100,
          cellRenderer: params => {
            if (!params.value) {
              return ''
            }
            return `<img src="data:image/jpeg;base64,${params.value}" fit="fill" style="height:25px;" >`
          },
          tooltipValueGetter: (params) => {
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Apply'),
          colId: 'check',
          field: 'check',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-checkbox'
          }
        }]
    },
    clear() {
      this.imageGrid.selectedData = null
    },
    async onRowClick(event) {
      if (!event || !event.data) return
      this.imageGrid.selectedData = event.data
    },
    fetchOfficeImage() {
      if (this.treeNode.uuid) {
        Promise.all([querySystemImageFunc(this.treeNode.uuid)]).then(([imageRes]) => {
          this.imageGrid.rowData = imageRes.data
        })
      }
    },
    fetchOffice() {
      this.clientNos = ''
      if (this.treeNode.uuid) {
        this.loading = getLoading()
        getOfficeByUuid(this.treeNode.uuid).then(res => {
          this.oneOffice = { ...res.data }
          // 处理officeEoriList排序
          this.oneOffice.officeEoriList.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
          this.isNewDelegation = Number(cache.config.get('isNewDelegation'))
          this.queryTaxPanelNoStr()
          if (this.$store.getters.isPlatform) {
            this.invoiceGrid.rowData = this.oneOffice.invoiceConfigs || []
            this.addSerialNumber(this.invoiceGrid.rowData)
          }
        }).finally((e) => {
          this.loading.close()
        })
      }
    },
    queryTaxPanelNoStr() {
      queryTaxPanelNoStr(this.treeNode.uuid).then(res => {
        this.clientNos = res.data
      })
    },
    toAddOffice() {
      if (!this.checkAvailableBranchCount()) {
        return
      }
      this.oneOffice = { ...this.initOneOffice, parentBranchUuid: this.treeNode.uuid, level: this.treeNode.branchLevel + 1 }
      this.editHandler(true)
      this.imageGrid.rowData = []
      this.invoiceGrid.rowData = []
    },
    popCopyOffice() {
      if (!this.checkAvailableBranchCount()) {
        return
      }
      this.copyOfficeDialog.isShow = true
    },
    checkAvailableBranchCount() {
      const { branchCountLimited, initBranchCount, validBranchCount } = this.$store.state.settings.bsLimitInfo
      if (branchCountLimited && validBranchCount >= 0) {
        if (this.officeCount - 1 >= initBranchCount + validBranchCount) {
          this.$confirm(this.$t('SystemMaintenance.AvailableOfficeOverMaxLimit'), this.$t('SystemMaintenance.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }).catch(() => {})
          return false
        }
      }
      return true
    },
    toCheckCopyOfficeDialog() {
      let error = ''
      if (!this.copyOfficeDialog.code.trim()) {
        error = this.$t('SystemMaintenance.CompanyCodeCannotBeEmpty2')
      } else if (!this.copyOfficeDialog.chineseName.trim()) {
        error = this.$t('SystemMaintenance.TheOfTheCompanyEmpty')
      } else if (!this.copyOfficeDialog.englishName.trim()) {
        error = this.$t('SystemMaintenance.TheOfTheCompanyEmpty')
      } else if (!this.copyOfficeDialog.currency.trim()) {
        error = this.$t('SystemMaintenance.LocalNotAllowedToEmpty')
      }
      if (error) {
        this.$message.error(error)
        return false
      }
      return true
    },
    toSubmitCopyOffice() {
      if (this.toCheckCopyOfficeDialog()) {
        this.loading = getLoading()
        copyOffice({ ...this.copyOfficeDialog, copyOfficeUuid: this.oneOffice.uuid, copyOfficeId: this.oneOffice.officeId }).then(res => {
          this.$message.success(this.$t('SystemMaintenance.CopyCompanySucceeded'))
          this.toCancelCopyOffice()
          this.$emit('refreshTree')
          // 刷新缓存
          this.updateOfficeData()
          this.copyOfficeDialog.isShow = false
        }).finally((e) => {
          this.loading.close()
        })
      }
    },
    toCancelCopyOffice() {
      this.copyOfficeDialog = {
        isShow: false,
        code: '',
        uuid: '',
        chineseName: '',
        englishName: '',
        currency: ''
      }
    },
    toAddDept() {
      this.$emit('addDept', { type: 'office', uuid: this.treeNode.uuid })
    },
    popBankAccount() {
      this.bankAccountDialog.visible = true
    },
    popInvoicingInfo() {
      this.loadTaxControlPanel()
      // this.invoicingInfoDialog.office = this.oneOffice
      // this.invoicingInfoDialog.visible = true
    },
    // 加载当前分公司税盘
    loadTaxControlPanel() {
      const self = this
      loadTaxControlPanelFunc(this.oneOffice.uuid).then(res => {
        if (res.data) {
          for (const data of res.data) {
            if (data.taxControlPanelUuid) {
              const list = []
              const array = data.taxControlPanelUuid.split(',')
              for (const d of array) {
                list.push(Number(d))
              }
              data.taxControlPanelUuidList = list
            }
          }
        }
        self.invoicingInfoDialog.taxControlPanels = res.data || []
        self.invoicingInfoDialog.office = this.oneOffice
        self.invoicingInfoDialog.visible = true
      })
    },
    onOfficeChange(data) {
      Object.assign(this.oneOffice, data)
    },
    setOfficeDefaultRmbAccount() {
    },
    setOfficeDefaultUsdAccount() {

    },
    popImageAddDialog() {
      this.imageDialog.isShowFormDialog = true
      this.imageDialog.oneImage = { ...this.imageDialog.initOneImage }
    },
    toBatchDelImage() {
      this.$confirm(this.$t('SystemMaintenance.AreYouSureToDelete'), this.$t('SystemMaintenance.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const index = this.imageGrid.rowData.indexOf(this.imageGrid.selectedData)
        if (index > -1) {
          this.imageGrid.rowData.splice(index, 1)
        }
        if (this.imageGrid.selectedData.uuid) {
          return batchDelImage([this.imageGrid.selectedData.uuid], { 'officeUuid': this.oneOffice.uuid })
        }
      }).finally(p => {
        this.$message.success(this.$t('SystemMaintenance.DeleteSuccess2'))
        this.loading.close()
      })
    },
    commitImage() {
      let error = false
      for (const data of this.imageGrid.rowData) {
        if (!data.name) {
          this.$message.warning(this.$t('SystemMaintenance.NameCannotBeEmpty'))
          error = true
          break
        } else if (!data.imageTypeUuid) {
          this.$message.warning(this.$t('SystemMaintenance.N0FileTypeNotSelected', [data.name]))
          error = true
          break
        }
      }
      if (!error) {
        saveImage(this.imageGrid.rowData, this.oneOffice.uuid).then(res => {
          this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
          this.imageDialog.isShowFormDialog = false
        })
      }
    },
    toChooseImage(file) {
      let chooseFile
      const reader = new FileReader()
      const that = this
      let fileName = ''
      if (file.length) {
        chooseFile = file['0']
      } else {
        chooseFile = file.raw
      }
      fileName = chooseFile.name
      reader.readAsDataURL(chooseFile) // 转base64
      reader.onload = function(e) {
        that.imageDialog.oneImage.imageFile = e.target.result.split('base64,')[1]
        that.imageDialog.oneImage.name = fileName
        that.imageDialog.currentFile = { name: fileName, size: chooseFile.size, type: chooseFile.type.split('/')[1].replace('jpeg', 'jpg') }
        const row = {
          name: fileName,
          imageTypeUuid: '',
          imageFile: that.imageDialog.oneImage.imageFile,
          check: false,
          uuid: '',
          officeId: that.oneOffice.officeId
        }
        that.imageGrid.rowData.push(row)
      }
    },
    toCheckForm() {
      let error = ''
      if (!this.oneOffice.code.trim()) {
        error = this.$t('SystemMaintenance.CompanyCodeCannotBeEmpty2')
      } else if (!this.oneOffice.chineseName.trim()) {
        error = this.$t('SystemMaintenance.TheOfTheCompanyEmpty')
      } else if (!this.oneOffice.englishName.trim()) {
        error = this.$t('SystemMaintenance.TheOfTheCompanyEmpty')
      } else if (!this.oneOffice.currency.trim()) {
        error = this.$t('SystemMaintenance.LocalNotAllowedToEmpty')
      }
      if (error) {
        this.$message.error(error)
        return false
      }
      return true
    },
    companyUuidChangeHandler(p) {
      if (p.uuid && p.linkedBranchId !== 0 && p.linkedBranchId !== this.oneOffice.officeId) {
        this.oneOffice.companyUuid = ''
        this.$message.warning(this.$t('Message.AlreadyAssociatedWithOtherBranches', [p.chineseName]))
      } else {
        this.oneOffice.companyUuid = p.uuid
      }
      this.haveCompanyUuidChange = true
    },
    toSaveOffice() {
      this.$refs.depositBankAccount.hanldeFormat()
      // 开票配置
      this.oneOffice.invoiceConfigs = []
      if (this.$store.getters.isPlatform) {
        this.oneOffice.invoiceConfigs = this.invoiceGrid.rowData
        // 开票配置
        if (this.$refs.officeInvoiceConfig) {
          this.oneOffice.officeInvoiceTitles = this.$refs.officeInvoiceConfig.titleGrid.rowData
        }
        // 进项税配置
        if (this.$refs.officeInputTaxConfig && this.$refs.officeInputTaxConfig.titleGrid.rowData && this.$refs.officeInputTaxConfig.titleGrid.rowData.length > 0) {
          if (this.oneOffice.officeInvoiceTitles && this.oneOffice.officeInvoiceTitles.length > 0) {
            // 合并 开票配置 与 进项税配置
            this.oneOffice.officeInvoiceTitles.forEach(officeInvoiceTitle => {
              const officeInputTaxConfig = this.$refs.officeInputTaxConfig.titleGrid.rowData.find(p => p.uuid === officeInvoiceTitle.uuid)
              if (officeInputTaxConfig) {
                officeInvoiceTitle.inputTaxInvoiceChannel = officeInputTaxConfig.inputTaxInvoiceChannel
                officeInvoiceTitle.inputTaxAppKey = officeInputTaxConfig.inputTaxAppKey
                officeInvoiceTitle.inputTaxAppSecret = officeInputTaxConfig.inputTaxAppSecret
                officeInvoiceTitle.inputTaxToken = officeInputTaxConfig.inputTaxToken
              }
            })
          } else {
            this.oneOffice.officeInvoiceTitles = this.$refs.officeInputTaxConfig.titleGrid.rowData
          }
        }
      }
      if (!this.oneOffice.officeInvoiceTitles) {
        this.oneOffice.officeInvoiceTitles = []
      }
      for (const data of this.oneOffice.officeInvoiceTitles) {
        if (!data.invoiceConfigs) {
          data.invoiceConfigs = []
        }
      }
      // 添加分公司or编辑公司
      if (this.toCheckForm()) {
        this.commitOffice()
      }
    },
    toCancelSaveOffice() {
      this.editHandler(false)
      this.fetchOffice()
    },
    toEditOffice() {
      this.editHandler(true)
    },
    toDel() {
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToDelete3'), this.$t('SystemMaintenance.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        delOfficeByUuid(this.oneOffice.uuid).then(res => {
          this.$emit('refreshTree')
          // 刷新缓存
          this.updateOfficeData()
        }).finally((e) => {
          this.loading.close()
        })
      })
    },
    async commitOffice() {
      this.loading = getLoading()
      saveOffice(this.oneOffice).then(res => {
        if (this.isNewDelegation && this.haveCompanyUuidChange) {
          updateLinkedBranchIdByOffice({ linkedBranchId: res.data.officeId, uuid: res.data.companyUuid }).then(res => {
            if (res.data) {
              for (const data of res.data) {
                updateBasicDataForSingle(basicCacheKeys.basic_data_Company, data)
              }
            }
            this.refreshFunc(res)
          })
        } else {
          this.refreshFunc(res)
        }
      }).finally((e) => {
        this.loading.close()
      })
    },
    refreshFunc(res) {
      Object.assign(this.oneOffice, res.data)
      this.$emit('refreshTree', res.data.uuid)
      this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
      // 刷新缓存
      this.updateOfficeData()
      this.editHandler(false)
    },
    cancelHandler() {
      this.bankAccountDialog.visible = false
    },
    updateClientNos() {
      this.queryTaxPanelNoStr()
    },
    updateOfficeData() {
      getUserOfficeList().then((res) => {
        const currentUserInfo = getUserInfo()
        currentUserInfo.currentUserOfficeList = [...res.data]
        this.$store.dispatch('user/setUserInfo', currentUserInfo)
      })
      syncSpecificBasicData(basicCacheKeys.basic_data_Office)
      syncSpecificBasicData(basicCacheKeys.basic_data_Office_All)
    },
    editHandler(edit) {
      this.isEdit = edit
      this.haveCompanyUuidChange = false
      this.$emit('editData', this.isEdit)
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    editClientNoHandler() {
      this.loading = getLoading()
      loadTaxControlPanelFunc(this.treeNode.uuid).then(res => {
        for (const data of res.data) {
          if (data.departmentIds) {
            const array = data.departmentIds.split(',')
            const list = []
            for (const d of array) {
              list.push(Number(d))
            }
            data.departmentIdList = list
          }
        }
        this.editClientNo.rowData = res.data
        this.editClientNo.deptList = this.deptList
        this.editClientNo.visible = true
      }).finally((e) => {
        this.loading.close()
      })
    },
    showAdvanceTextDialog01(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    showBlAddressDialog() {
      this.showAdvanceTextDialog01(this.$t('Partners.oceanBillOfLadingAddress'), this.mergeBlAddressLine(), this.splitBlAddressLine, false, {
        maxChar: 255, autoUppercase: true, autoHalfWord: true
      })
    },
    showAirAddressDialog() {
      this.showAdvanceTextDialog01(this.$t('Partners.airBillOfLadingAddress'), this.mergeAirAddressLine(), this.splitAirAddressLine, false, {
        maxChar: 255, autoUppercase: true, autoHalfWord: true
      })
    },
    splitBlAddressLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 6; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.oneOffice['seaAddressLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.oneOffice['seaAddressLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.oneOffice['seaAddressLine' + i] = ''
      }
    },
    splitAirAddressLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 6; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.oneOffice['airAddressLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.oneOffice['airAddressLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.oneOffice['airAddressLine' + i] = ''
      }
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    mergeBlAddressLine() {
      let result = ''
      for (let i = 1; i < 6; ++i) {
        result += this.oneOffice['seaAddressLine' + i] || ''
        result += '\n'
      }
      result += (this.oneOffice['seaAddressLine6'] || '')
      return result.trimEnd()
    },
    mergeAirAddressLine() {
      let result = ''
      for (let i = 1; i < 6; ++i) {
        result += this.oneOffice['airAddressLine' + i] || ''
        result += '\n'
      }
      result += (this.oneOffice['airAddressLine6'] || '')
      return result.trimEnd()
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    invoiceChannelChange() {
      this.oneOffice.appKey = ''
      this.oneOffice.appSecret = ''
      this.oneOffice.token = ''
      this.oneOffice.invoicerConfig = 0
      if (!this.oneOffice.invoiceChannel || this.oneOffice.invoiceChannel === 0 || (this.invoiceGrid.rowData && this.invoiceGrid.rowData.length > 0)) {
        for (const invocieConfig of this.invoiceGrid.rowData) {
          this.invoicerDel(invocieConfig.uuid, invocieConfig.serialNumber)
        }
      }
      if (!this.invoiceGrid.rowData || this.invoiceGrid.rowData.length <= 0) {
        this.invoicerAdd()
      }
    },
    // 新增开票员
    invoicerAdd() {
      if (!this.isEdit) return
      if (!this.checkInvoiceConfig()) return
      const newInvoicer = {
        serialNumber: 0,
        invoicer: 0,
        extensionNumber: '',
        terminalCode: '',
        userCode: '',
        remark: '',
        officeUuid: this.oneOffice.uuid
      }
      this.invoiceGrid.rowData.push(newInvoicer)
      this.addSerialNumber(this.finalInvoiceRowData)
    },
    // 删除开票员
    invoicerDel(uuid, serialNumber) {
      if (!this.isEdit) return
      if (this.invoiceGrid.rowData && this.invoiceGrid.rowData.length > 0) {
        for (const invocieConfig of this.invoiceGrid.rowData) {
          if (invocieConfig.uuid && uuid && invocieConfig.uuid === uuid) {
            invocieConfig.serialNumber = 0
            invocieConfig.deleted = true
          }
        }
      }
      if ((uuid === 'undefined' || !uuid) && serialNumber) {
        this.invoiceGrid.rowData = this.invoiceGrid.rowData.filter(row => row.serialNumber !== serialNumber)
      }
      // 至少要留一条数据
      if (!this.finalInvoiceRowData || this.finalInvoiceRowData.length <= 0) {
        this.invoicerAdd()
      }
      this.addSerialNumber(this.finalInvoiceRowData)
    },
    // 显示列增加序号
    addSerialNumber(rowData) {
      if (rowData && rowData.length > 0) {
        rowData.forEach((item, index) => {
          if (!item.deleted) {
            item.serialNumber = index + 1
          }
        })
      }
    },
    // 验证分机号开票员是否填写完整
    checkInvoiceConfig() {
      const rowData = this.finalInvoiceRowData
      if (rowData && rowData.length > 0) {
        for (const item of rowData) {
          if (!item.invoicer || item.invoicer === 0) {
            this.$message.warning(this.$t('CargoMsg.Invoicer') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
            return false
          }
          if (this.isNuoNuo) {
            if (!item.extensionNumber) {
              this.$message.warning(this.$t('CargoMsg.ExtensionNumber') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
              return false
            }
          }
          if (this.isBwjsy) {
            if (!item.userCode) {
              this.$message.warning(this.$t('CargoMsg.FEI_Yhdm') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
              return false
            }
            if (!item.terminalCode) {
              this.$message.warning(this.$t('CargoMsg.FEI_Kpzddm') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
              return false
            }
          }
        }
      }
      return true
    },
    changeNoHouseNumberFlag() {
      this.eoriInfo.streetNo = this.eoriInfo.noHouseNumberFlag ? 'N/A' : ''
    },
    eoriAddHandler() {
      // 检查是否达到上限
      if (!this.canAddEori) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AdditionFailed'))
        return
      }

      // 获取海运提单地址
      const blAddress = this.mergeBlAddressLine()

      // 初始化新的 EORI 信息对象
      this.eoriInfo = {
        name: (this.oneOffice.englishName || '').substring(0, 70),
        address1: blAddress.length > 35 ? blAddress.substring(0, 35) : blAddress,
        address2: blAddress.length > 35 ? blAddress.substring(35, 70) : '',
        streetNo: 'N/A',
        noHouseNumberFlag: true,
        postalcode: '',
        tel: '',
        city: '',
        country: '',
        email: '',
        eori: '',
        dateCreated: new Date().toISOString(),
        newUuid: UIDUtil.createUID()
      }

      this.eoriInfoDialog.action = 'add'
      // 打开 EORI 信息编辑弹窗
      this.eoriInfoDialog.visible = true
    },
    // 新增电话号码格式化方法
    formatPhoneNumber(phone) {
      if (!phone) return ''
      return phone.startsWith('+') ? phone : `+${phone}`
    },
    onCellChange(params) {
      if (params.colDef.field === 'defaultInvoiceIssuer') {
        for (const data of this.finalInvoiceRowData) {
          data.defaultInvoiceIssuer = false
        }
        if (params.newValue) {
          params.data.defaultInvoiceIssuer = true
        }
      }
      this.invoiceGrid.gridOptions.api.refreshCells({ force: true })
    },
    // EORI 编辑处理
    eoriEditHandler(item) {
      // 打开窗口处理勾选问题
      item.noHouseNumberFlag = !item.streetNo || item.streetNo === 'N/A'
      // 处理编辑逻辑
      this.eoriInfo = { ...item }
      this.eoriInfoDialog.action = 'update'
      this.eoriInfoDialog.visible = true
    },
    // EORI 删除处理
    eoriDeleteHandler(item) {
      this.$confirm(this.$t('CargoMsg.Cargo_DeleteEORITip'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        if (!item.uuid) {
          // 不存在UUID在原数组中删除
          const index = this.oneOffice.officeEoriList.findIndex(eori => eori.eori === item.eori)
          if (index > -1) {
            this.oneOffice.officeEoriList.splice(index, 1)
          }
        } else {
          // 如果存在UUID将标记为删除状态
          const index = this.oneOffice.officeEoriList.findIndex(eori => eori.uuid === item.uuid)
          if (index > -1) {
            this.oneOffice.officeEoriList[index].action = 'delete'
          }
        }
      }).catch(() => {})
    },
    // EORI 信息保存处理
    saveEoriInfo() {
      // 校验必填字段
      const requiredFields = [
        { field: 'name', label: this.$t('SeaExport.CompanyTitle') },
        { field: 'address1', label: this.$t('SeaExport.Addr') + '1' },
        { field: 'streetNo', label: this.$t('SeaExport.HouseNumber') },
        { field: 'postalcode', label: this.$t('SeaExport.ZIP') },
        { field: 'city', label: this.$t('SeaExport.City') },
        { field: 'country', label: this.$t('SeaExport.Country') },
        { field: 'eori', label: 'EORI' }
      ]

      for (const { field, label } of requiredFields) {
        if (!this.eoriInfo[field]?.trim()) {
          this.$message.warning(`${label}${this.$t('CargoMsg.Cargo_CanNotEmpty')}`)
          return
        }
      }

      // 检查 EORI 是否重复
      const isDuplicate = this.oneOffice.officeEoriList.some(item => {
        // 跳过已删除的记录
        if (item.action === 'delete') return false

        // 跳过当前正在编辑的记录
        if (this.eoriInfoDialog.action === 'update') {
          if (item.uuid === this.eoriInfo.uuid && item.eori === this.eoriInfo.eori) {
            return false
          }
        }

        // 比较 EORI 值
        return item.eori === this.eoriInfo.eori
      })

      if (isDuplicate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EORINotDuplicate'))
        return
      }

      // 在保存前处理电话号码格式
      this.eoriInfo.tel = this.formatPhoneNumber(this.eoriInfo.tel)

      try {
        if (this.eoriInfoDialog.action === 'add') {
          // 新增时要标记为新增的元素
          this.eoriInfo.action = 'add'
          this.eoriInfo.dateCreated = new Date().toISOString()
          this.oneOffice.officeEoriList.push({ ...this.eoriInfo })
        } else if (this.eoriInfoDialog.action === 'update') {
          // 编辑时要标记为更新的元素
          let index = -1
          if (this.eoriInfo.action === 'add') {
            index = this.oneOffice.officeEoriList.findIndex(item => item.newUuid === this.eoriInfo.newUuid)
          } else {
            index = this.oneOffice.officeEoriList.findIndex(item => item.uuid === this.eoriInfo.uuid)
          }
          if (index > -1) {
            // 如果是已有记录，标记为更新
            if (this.eoriInfo.uuid) {
              this.eoriInfo.action = 'update'
              this.eoriInfo.dateModified = new Date().toISOString()
            }
            // 使用展开运算符创建新对象，避免引用问题
            this.oneOffice.officeEoriList[index] = { ...this.eoriInfo }
          }
        }

        // 处理排序
        this.oneOffice.officeEoriList.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))

        // 完成后关闭弹窗并显示成功提示
        this.eoriInfoDialog.visible = false
      } catch (error) {
        console.error('保存 EORI 信息失败:', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.input-dialog ::v-deep {
  .input-color.el-input {
    .el-input__inner {
      border-color: #DCDFE6 !important;
    }
  }
  .el-input-number {
    .el-input__inner {
      border-color: #DCDFE6 !important;
    }
  }
  .el-textarea {
    .el-textarea__inner {
      border-color: #DCDFE6 !important;
    }
  }
}

.eori-list {
  width: 100%;
  .eori-item {
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.eori-dialog ::v-deep {

  .el-dialog__header {
    border: none;
  }

  .el-dialog__body {
    font-size: 14px !important;
    padding: 0 !important;
  }

  .el-dialog__footer {
    margin-top: 20px;
    border: none;
  }

}

.center-label{
  margin-left: 5px;
  margin-right: 5px;
  width: 110px;
}
</style>
